export default "__VITE_ASSET__BPTCDp4I__"